/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './us';
import './ca';
import './gb';
import './au';
import './jp';
import './es';
import './ie';
import './fr';
import './automated_business_info';
import '../../common/location';
import '../common';
import '../../onboard/activation/service';
import '../../common/messages';
import './common';
import './bic';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "external": {
                "nested": {
                  "UpdateRequest": {
                    "fields": {
                      "usBusiness": {
                        "type": ".squareup.onboarding.business.UsBusiness",
                        "id": 1
                      },
                      "caBusiness": {
                        "type": ".squareup.onboarding.business.CaBusiness",
                        "id": 2
                      },
                      "gbBusiness": {
                        "type": ".squareup.onboarding.business.GbBusiness",
                        "id": 3
                      },
                      "auBusiness": {
                        "type": ".squareup.onboarding.business.AuBusiness",
                        "id": 4
                      },
                      "jpBusiness": {
                        "type": ".squareup.onboarding.business.JpBusiness",
                        "id": 5
                      },
                      "esBusiness": {
                        "type": ".squareup.onboarding.business.EsBusiness",
                        "id": 6
                      },
                      "ieBusiness": {
                        "type": ".squareup.onboarding.business.IeBusiness",
                        "id": 7
                      },
                      "frBusiness": {
                        "type": ".squareup.onboarding.business.FrBusiness",
                        "id": 8
                      }
                    },
                    "nested": {
                      "business": {
                        "oneof": ["usBusiness", "caBusiness", "gbBusiness", "auBusiness", "jpBusiness", "esBusiness", "ieBusiness", "frBusiness"]
                      }
                    }
                  },
                  "BicPredictRequest": {
                    "fields": {
                      "businessDescription": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "AutomatedBusinessInfoUpdateRequest": {
                    "fields": {
                      "automatedBusinessInfo": {
                        "type": ".squareup.onboarding.business.AutomatedBusinessInfo",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateAddressRequest": {
                    "fields": {
                      "globalAddress": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 1,
                        "rule": "optional"
                      },
                      "globalIndividualAddress": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 2,
                        "rule": "optional"
                      },
                      "globalTradingAddress": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessExternalService": {
                    "methods": {
                      "Update": {
                        "requestType": ".squareup.onboarding.business.external.UpdateRequest",
                        "responseType": ".squareup.onboarding.common.StatusResponse"
                      },
                      "AutomatedBusinessInfoUpdate": {
                        "requestType": ".squareup.onboarding.business.external.AutomatedBusinessInfoUpdateRequest",
                        "responseType": ".squareup.onboarding.common.StatusResponse"
                      },
                      "GetCategories": {
                        "requestType": ".squareup.onboard.activation.service.BusinessCategoriesRequest",
                        "responseType": ".squareup.onboard.activation.service.BusinessCategoriesResponse"
                      },
                      "GetMerchantCategories": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboarding.business.common.GetMerchantCategoriesResponse"
                      },
                      "GetBusinessStructure": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.service.GetBusinessStructureResponse"
                      },
                      "UpdateBusinessStructure": {
                        "requestType": ".squareup.onboard.activation.service.UpdateBusinessStructureRequest",
                        "responseType": ".squareup.onboard.activation.service.UpdateBusinessStructureResponse"
                      },
                      "BicPredict": {
                        "requestType": ".squareup.onboarding.business.external.BicPredictRequest",
                        "responseType": ".squareup.onboarding.business.BicPredictResponse"
                      },
                      "UpdateAddress": {
                        "requestType": ".squareup.onboarding.business.external.UpdateAddressRequest",
                        "responseType": ".squareup.onboarding.common.StatusResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.UpdateRequest && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.BicPredictRequest && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.AutomatedBusinessInfoUpdateRequest && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.UpdateAddressRequest && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.external?.nested?.BusinessExternalService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateRequest @ squareup/onboarding/business/external.proto at 85:1
 */
export const UpdateRequest = $root.lookupType('squareup.onboarding.business.external.UpdateRequest');
fixType(UpdateRequest);
Builder.createAndAttachToType(UpdateRequest);
/**
 * SOURCE BicPredictRequest @ squareup/onboarding/business/external.proto at 98:1
 */
export const BicPredictRequest = $root.lookupType('squareup.onboarding.business.external.BicPredictRequest');
fixType(BicPredictRequest);
Builder.createAndAttachToType(BicPredictRequest);
/**
 * SOURCE AutomatedBusinessInfoUpdateRequest @ squareup/onboarding/business/external.proto at 102:1
 */
export const AutomatedBusinessInfoUpdateRequest = $root.lookupType('squareup.onboarding.business.external.AutomatedBusinessInfoUpdateRequest');
fixType(AutomatedBusinessInfoUpdateRequest);
Builder.createAndAttachToType(AutomatedBusinessInfoUpdateRequest);
/**
 * SOURCE UpdateAddressRequest @ squareup/onboarding/business/external.proto at 106:1
 */
export const UpdateAddressRequest = $root.lookupType('squareup.onboarding.business.external.UpdateAddressRequest');
fixType(UpdateAddressRequest);
Builder.createAndAttachToType(UpdateAddressRequest);
/**
 * SOURCE BusinessExternalService @ squareup/onboarding/business/external.proto at 26:1
 */
export const BusinessExternalService = $root.lookupService('squareup.onboarding.business.external.BusinessExternalService');